import React from "react";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";


export default function TransactionCreditHeadings({view, filters, setFilters, setPage, data}){

    const headings = [
        {
            label: "Transaction Id",
            show: true
        },
        {
            label: "Transaction Type",
            show: true
        },
        {
            label: "Transaction Description",
            show: true
        },
        {
            label: "Credit Description",
            show:true
        },
        {
            label: "Contact",
            show: true
        },
        {
            label: "VAT Nominal Code",
            show: true
        },
        {
            label: "No VAT Nominal Code",
            show: true
        },
        {
          label: "Credit Note Number",
          show: true
        },
        {
            label: "Date Issued",
            show: true
        },
        {
            label: "Amount Credited",
            show: true
        },
        {
          label: "Non VAT Amount Credited",
          show: true
        },
        {
            label: "",
            show: true
        },
        {
            label: "",
            show: true
        }
    ]



    return (
      <tr>
          {headings.map(heading => {
              if(heading.show) {
                  if (!heading.field) {
                        return <th key={heading.label}>{heading.label}</th>;
                  }
                  if (heading.blank) {
                      return (
                          <FilterBlankHeading
                              key={heading.label}
                              heading={heading}
                              setFilters={f => {
                                  setPage(1);
                                  setFilters(f);
                              }}
                              filters={filters}
                          />
                      );
                  }
                  return (
                      <FilterHeading
                          key={heading.label}
                          heading={heading}
                          setFilters={f => {
                              setPage(1);
                              setFilters(f);
                          }}
                          filters={filters}
                          options={data.filter_list[heading.field] ?? []}
                      />
                  );
              }
          })}
      </tr>
  )

}